import React, {createContext, useMemo, useState} from 'react'
import AttachmentsCollection from "../../../../model2/attachment/attachments"

const debug = false
// const debug = "AttachmentsContext"

export type AttachmentsPluginContextShape = {
    attachmentInMessageDefaultWidth?    : number | string
    attachmentInEditorIsResizeable?     : boolean
    attachmentsCollection?              : AttachmentsCollection
    set                                 : (
        attachmentsCollection?: AttachmentsCollection,
    ) => void
}

export const AttachmentsPluginContext = createContext<AttachmentsPluginContextShape>({
    attachmentInMessageDefaultWidth : undefined,
    attachmentInEditorIsResizeable  : true,
    set                             : ()=>{} // default set function
})

export default function AttachmentsContext({attachmentInMessageDefaultWidth, attachmentInEditorIsResizeable, children}: {
    attachmentInMessageDefaultWidth?    : number | string
    attachmentInEditorIsResizeable?     : boolean
    children                            : JSX.Element
}) {
    const [contextValue, setContextValue] = useState<{
        attachmentsCollection?              : AttachmentsCollection
    }>({
        attachmentsCollection           : undefined
    });
    return (
        <AttachmentsPluginContext.Provider
            value={useMemo(
                () => ({
                    attachmentInMessageDefaultWidth : attachmentInMessageDefaultWidth,
                    attachmentInEditorIsResizeable  : attachmentInEditorIsResizeable,
                    attachmentsCollection           : contextValue.attachmentsCollection,
                    set                             : (attachmentsCollection) => {
                        setContextValue({attachmentsCollection});
                    },
                }),
                [contextValue.attachmentsCollection],
            )}>
            {children}
        </AttachmentsPluginContext.Provider>
    );
}
